// used in FormDecorator
export enum StatusGroupType {
  all = 'All Statuses & Steps',
  incomplete = 'Incomplete',
  complete = 'Complete',
}

// used in LicenseDecorator
export enum LicenseStatusGroupType {
  all = 'All Statuses'
}